
import Vue from "vue";
import {Contact} from "@/models/base";
import {IParticipantInfoResponse, PeppolService} from "@/services/peppol-service";

export default Vue.extend({
	data() {
		return {
			checkResponse: null as null | IParticipantInfoResponse,
			init: false
		};
	},
	props: {
		contact: {
			type: Object as() => Contact,
			required: true
		},
		hideInfo: Boolean,
		alwaysShow: Boolean
	},
	computed: {
		showPeppolStatus():boolean{
			if(!this.contact) return false;
			if (this.alwaysShow) return true;
			return !!(this.contact.Vat || this.contact.CommercialVat || this.contact.PeppolEndpointID);
		},
		partialCompatibility():string {
			if (!this.checkResponse || !this.checkResponse.Registered) return "";
			if (this.checkResponse.IsInvoiceCompatible && !this.checkResponse.IsCreditNoteCompatible) return this.$ct("peppol-only-invoice-compatible").toString();
			if (this.checkResponse.IsCreditNoteCompatible && !this.checkResponse.IsInvoiceCompatible) return this.$ct("peppol-only-credit-note-compatible").toString();
			if (this.noCompatibility) return this.$ct("peppol-registered-but-no-compatible-documents").toString();
			return "";
		},
		noCompatibility():boolean {
			if (!this.checkResponse || !this.checkResponse.Registered) return true;
			if (!this.checkResponse.IsCreditNoteCompatible && !this.checkResponse.IsInvoiceCompatible) return true;
			return false;
		}
	},
	watch: {},
	methods: {
		async refresh(){
			if (this.contact && this.showPeppolStatus) {
				try {
					this.checkResponse = await PeppolService.getParticipantInfo(this.contact.PeppolEndpointID || this.contact.Vat || this.contact.CommercialVat || "");
					this.$emit("result",this.checkResponse);
					this.init = true;
					return;
				} catch(err) {
					this.init = true;
					this.$emit("result", null);
				}
			}else{
				this.init = false;
			}
			this.checkResponse = {
				Registered: false,
				IsCreditNoteCompatible: false,
				IsInvoiceCompatible: false,
				IsSelfBilledCreditNoteCompatible: false,
				IsSelfBilledInvoiceCompatible: false,
				DocumentTypes: []
			};
		}
	},
	async mounted(){
		await this.refresh();
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
